import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import "../styles/global.css";

export function AppShell() {
  const { pathname } = useLocation();
  const isWorkspace = pathname === "/app" || pathname.startsWith("/app/");
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <header className="site-header">
        <Link className="brand" to="/" aria-label="Your Next Gameweek home">
          <span className="brand-mark" aria-hidden="true">YN</span>
          <span>Your Next Gameweek</span>
        </Link>
        <nav className="site-nav" aria-label="Primary navigation">
          {isWorkspace ? <><NavLink to="/app" end={false} className={({ isActive }) => isActive && pathname !== "/app/team" ? "active" : undefined}>Latest plan</NavLink><NavLink to="/app/team" className={({ isActive }) => isActive ? "active" : undefined}>Team settings</NavLink></> : <>{pathname !== "/" && <Link to="/">Public planner</Link>}<Link className="site-nav-action" to="/auth/login">Sign in</Link></>}
        </nav>
      </header>
      <main id="main-content" className={`page-container${isWorkspace ? " workspace-page" : ""}`}><Outlet /></main>
      <footer className="site-footer">Plan the next move with clarity.</footer>
    </>
  );
}
